module.exports = __webpack_public_path__ + "img/213.23e95d19.png";